<template>
  <div id="bus">
    <div class="logo">
      <p>Skyttelbussen går mellan Frösundavik och Solna Station på vardagar mellan kl. 7-9:30 och 15-18.</p>
      <img src="./assets/Gate01_Frosunda_black.png" />
      <!--<p>Onsdagen den 29 maj (dagen före Kristi Himmelfärdsdag) kommer skyttelbussen att gå eftermiddagen mellan 12:00 och 15:00 istället för ordinarie tidtabell. På morgonen går bussen som vanligt.</p>
      <p>On Wednesday May 29th (the day before Ascension Day), the shuttle bus will run between 12 pm and 3 pm instead of the regular afternoon schedule. The morning schedule runs as usual.</p>-->
    </div>
    <alert />
    <GmapMap
      :center="center"
      :zoom="15"
      :options="{
        disableDefaultUI: true
      }"
      ref="mapRef"
    >
      <gmap-marker :position="marker.position" :icon="marker.icon"></gmap-marker>
    </GmapMap>
  </div>
</template>

<script>
import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'
import axios from 'axios'
import Alert from './components/Bus/Alert.vue'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBfGO5kM0J6M0N7N5wtRe_GSqpYuDd8KhU'
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)
    // If you want to set the version, you can do so:
    // v: '3.26',
  }
})

export default {
  data () {
    return {
      pollingRate: 1000,
      center: { lat: 59.3655941, lng: 18.011918 },
      lat: 0,
      lng: 0,
      markers: [],
      marker: {},
      interval: null,
      cachedData: []
    }
  },
  created () {
    this.loadData()
    this.interval = setInterval(() => {
      this.loadData()
    }, this.pollingRate)
  },
  beforeDestroy () {
    clearInterval(this.interval)
    this.interval = null
  },
  mounted () {
    // At this point, the child GmapMap has been mounted, but
    // its map has not been initialized.
    // Therefore we need to write mapRef.$mapPromise.then(() => ...)
    this.$refs.mapRef.$mapPromise.then(() => {
      this.marker = {
        position: {
          lat: this.lat,
          lng: this.lng
        },
        icon: {
          url: require('./assets/bus.png'),
          size: this.google && this.google.maps && new this.google.maps.Size(40, 40),
          // The origin for this image is (0, 0).
          origin: this.google && this.google.maps && new this.google.maps.Point(0, 0),
          // The anchor for this image is the base of the flagpole at (0, 32).
          anchor: this.google && this.google.maps && new this.google.maps.Point(20, 20)
        }
      }
    })
  },
  methods: {
    loadData () {
      // axios.get(`http://localhost:8080/api/positioning/read.php`)
      // axios.get(`http://10.0.1.15:8080/api/positioning/read.php`)
      axios.get(`https://gate01.se/api/positioning/read.php`)
        .then(response => {
          if (response && response.data) {
            this.cachedData = response.data
            this.lat = +this.cachedData.y
            this.lng = +this.cachedData.x
            this.marker.position = {
              lat: +this.cachedData.y,
              lng: +this.cachedData.x
            }
            // console.log(this.lng, this.lat, 'update')
          }
        }).catch(() => {
          // console.log(e)
          // offline
          // this.cachedData.forEach(station => {
          //   let data = JSON.parse(station.response_data)
          //   Vue.set(this.stations, station.site_id, data)
          // })
        })
    }
  },
  computed: {
    google: VueGoogleMaps.gmapApi
  },
  components: {
    Alert
  }
}
</script>

<style lang="scss">
  @import 'style/app.scss';
  #bus {
    // .alert {
    //   position: absolute;
    //   top: 10%;
    //   left: 0;
    //   width: 100vw;
    //   z-index: 10;
    //   padding: 2rem 0;
    //   background: rgba(0, 0, 0, 0.5);
    //   p {
    //     padding: 0 2rem;
    //     font-size: 1.6rem;
    //     line-height: 2.5rem;
    //     + p {
    //       margin-top: 5rem;
    //     }
    //   }
    // }

    .alert {
        padding: 2rem;
        background: rgba(0, 0, 0, 0.5);
        p {
            font-size: 1.6rem;
            line-height: 2rem;
            + p {
                margin-top: 2rem;
            }
        }
    }

    background: white;
    color: white;
    padding: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: absolute;
    // @media (min-width: 1050px) {
    //   width: 1080px;
    //   height: 1920px;
    // }
    .vue-map-container {
      width: 100%;
      height: 100%;
    }
    .logo {
      background: rgba(255,255,255,.9);
      bottom: 25px;
      color: black;
      display: block;
      margin: 0 auto;
      padding: 1rem;
      position: fixed;
      text-align: center;
      z-index: 1000;
      left: 0;
      right: 0;
    }
  }
</style>
